// src/processors/resource/resource-processor.ts - Main Resource Processor
import {  XConVitePluginOptions } from '../../types';
import { ResourceFileHandler } from './resource-file-handler';
import { ResourceParser } from './resource-parser';
import { ResourceValidator } from './resource-validator';
import { ResourceUrlProcessor } from './resource-url-processor';
import {Logger} from "../../utils/logger";
import {ProcessResult} from "../../types";
/**
 * Main resource processor that orchestrates all resource processing operations
 * Only processes resources property in widget decorator - no longer processes xchtml files
 */
export class ResourceProcessor {
    private fileHandler: ResourceFileHandler;
    private parser: ResourceParser;
    private validator: ResourceValidator;
    private urlProcessor: ResourceUrlProcessor;

    constructor(
        private options: Required<XConVitePluginOptions>,
        private logger: Logger
    ) {
        this.fileHandler = new ResourceFileHandler(options, logger);
        this.parser = new ResourceParser(options, logger);
        this.validator = new ResourceValidator(options, logger);
        this.urlProcessor = new ResourceUrlProcessor(options, logger);
    }

    /**
     * Process resources - only in widget decorator, no longer from xchtml files
     */
    processResources(
        code: string,
        id: string,
        addWatchFile: (file: string) => void
    ): ProcessResult {
        let transformedCode = code;
        let hasChanges = false;

        // Only process resources array that already exists in the widget decorator
        transformedCode = transformedCode.replace(
            /resources:\s*\[([\s\S]*?)\]/g,
            (match, resourcesContent) => {
                try {
                    // If already populated array exists, don't change it
                    if (this.hasExistingResources(resourcesContent)) {
                        return match;
                    }

                    // Return empty array if no existing resources
                    return 'resources: []';
                } catch (error) {
                    this.logger.error(`Resources processing error:`, error);
                    return 'resources: []';
                }
            }
        );

        return { code: transformedCode, changed: hasChanges };
    }

    /**
     * Check if resources array already has content
     */
    private hasExistingResources(resourcesContent: string): boolean {
        const trimmed = resourcesContent.trim();
        return trimmed !== '' && trimmed !== '[]';
    }
}